import { makeApi } from "./callApi";
import { getLocation } from "../utils/helper";
export class OrderApi {
    static async createOrder(orderData) {
        const response = await makeApi("/customer/order/create", "POST", {
            locationDetails: getLocation(),
            ...orderData,
        });
        return response.data;
    }

    static async getOrders(payload) {
        const response = await makeApi("/customer/order/find-all", "POST", payload);
        return response.data;
    }

    static async getOrderDetails(orderId) {
        const response = await makeApi(`/customer/order/${orderId}`, "GET", {});
        return response.data;
    }

    static async rateOrder(orderId, payload) {
        const response = await makeApi(`/customer/order/${orderId}/order-feedback`, "POST", payload);
        return response.data;
    }
}
